export enum FontSize {
    EXTRA_SMALL = 'extra-small',
    SMALL = 'small',
    REGULAR = 'regular',
    BIG = 'big'
}
